import cn from 'classnames';
import React from 'react';

const ButtonLoader = ({className}) => {
    return (
        <div
            className={cn(
                'inline-block h-4 w-4 animate-spin rounded-full border-[2px] border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]',
                className
            )}
            role='status'
        />
    );
};

export default ButtonLoader;
